import { PartialTranslation } from '../translations';

export const lv: PartialTranslation = {
  newChat: 'Jauna saruna',
  search: 'Meklēt',
  user: 'Lietotājs',
  settings: 'Iestatījumi',
  language: 'Valoda',
  getHelp: 'Saņemt palīdzību',
  viewAllPlans: 'Skatīt visus plānus',
  learnMore: 'Uzzināt vairāk',
  logOut: 'Iziet',
  chooseLanguage: 'Bize lingvon',
  chooseYourPreferredLanguage: 'Bize vian preferatan lingvon',
  searchLanguages: 'Serĉi lingvojn...',
  autoDetect: 'Automātiska noteikšana',
  noLanguagesFound: 'Neniuj lingvoj trovitaj',
  askAnything: 'Jautājiet jebko',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Personīgs',
  freePlan: 'Bezmaksas plāns',
  current: 'Nuna',
  close: 'Fermi',
  archive: 'Arkivigi',
  delete: 'Forigi',
  confirmDelete: 'Ĉu vi certas ke vi volas forigi ĉi tiun babilon?',
  confirmArchive: 'Ĉu vi certas ke vi volas arkivigi ĉi tiun babilon?',
  deleteCannotUndo: 'Ĉi tiu ago ne povas esti malfari.',
  archiveCanFind: 'Vi povas trovi ĝin en la arkiva listo post arkivigo.',
  
  // 资源面板
  resources: 'Resursi',
  addResource: 'Pievienot resursu',
  deleteResource: 'Forigi rimedon',
  noMatchingResourcesFound: 'Neniuj kongruaj rimedoj trovitaj',
  noResourcesAvailable: 'Neniuj rimedoj disponeblaj',
  hideResources: 'Kaŝi rimedojn',
  showResources: 'Montri rimedojn',
  
  // 聊天输入框
  typeMessage: 'Rakstiet ziņojumu...',
  thinkingOptions: 'Pensaj opcioj',
  deleteFile: 'Forigi dosieron',
  clearSelection: 'Viŝi selekton',
  addAttachment: 'Pievienot pielikumu',
  sendMessage: 'Nosūtīt ziņojumu',
  
  // 思考模式选项
  deepInsight: 'Profunda kompreno · Surfaca analizo',
  deepInsightDesc: 'Rapida kompreno de ŝlosilaj punktoj',
  deepExploration: 'Profunda esplorado · Ampleksa analizo',
  deepExplorationDesc: 'Multdimensia profunda esplorado',
  deepDeconstruction: 'Profunda malkonstruado · Sistema argumento',
  deepDeconstructionDesc: 'Tavolo post tavolo progresa analizo',
  
  // 写作模式选项
  contractReview: 'Kontrakta revizio · Risko identigo',
  contractReviewDesc: 'Klausola analizo kaj konformeca kontrolo',
  textPolish: 'Teksta poluro · Profesia esprimo',
  textPolishDesc: 'Lingva optimumigo kaj struktura alĝustigo',
  legalDocuments: 'Leĝaj dokumentoj · Norma malneto',
  legalDocumentsDesc: 'Profesia leĝa dokumento skribado',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Pieteikties',
  register: 'Reģistrēties',
  welcomeBack: 'Laipni lūdzam LawHelper',
  loginSubtitle: 'Jūsu AI juridiskais pētījumu asistents',
  continueWithGoogle: 'Turpināt ar Google',
  continueWithMicrosoft: 'Turpināt ar Microsoft',
  continueWithWeChat: 'Turpināt ar WeChat',
  orContinueWith: 'vai turpināt ar',
  emailTab: 'E-pasts',
  phoneTab: 'Tālrunis',
  emailPlaceholder: 'Ievadiet savu e-pastu',
  phonePlaceholder: 'Ievadiet tālruņa numuru',
  codePlaceholder: 'Ievadiet 6 ciparu kodu',
  sending: 'Sūta...',
  verifying: 'Pārbauda...',
  verify: 'Apstiprināt',
  sendMagicLink: 'Sūtīt burvju saiti',
  getVerificationCode: 'Saņemt kodu',
  resendCode: 'Sūtīt kodu vēlreiz',
  resendIn: 'Sūtīt vēlreiz pēc',
  magicLinkSent: 'Burvju saite nosūtīta uz jūsu e-pastu',
  magicLinkHint: 'Mēs nosūtīsim drošu saiti uz jūsu e-pastu',
  otpSent: 'Verifikācijas kods nosūtīts',
  agreeToTerms: 'Turpinot jūs piekrītat mūsu',
  privacyPolicy: 'Privātuma politika',
  termsOfService: 'Pakalpojuma noteikumi',
  and: 'un',
  privacyTitle: 'Jūsu privātums ir svarīgs',
  privacyIntro: 'Mēs izmantojam sīkdatnes un līdzīgas tehnoloģijas, lai sniegtu vislabāko pieredzi.',
  essentialCookies: 'Būtiskās sīkdatnes',
  essentialDesc: 'Nepieciešamas vietnes darbībai',
  analyticsCookies: 'Analītiskās sīkdatnes',
  analyticsDesc: 'Palīdz mums uzlabot pakalpojumu',
  marketingCookies: 'Mārketinga sīkdatnes',
  marketingDesc: 'Tiek izmantotas personalizētam saturam',
  acceptAll: 'Pieņemt visas',
  essentialOnly: 'Tikai būtiskās',
  customize: 'Pielāgot',
  savePreferences: 'Saglabāt iestatījumus',
  back: 'Atpakaļ',
  readPrivacyPolicy: 'Izlasiet mūsu privātuma politiku',
  cookiePolicy: 'Sīkdatņu politika',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI pārskats',
  aiDraft: 'AI projekts',
  smartAssistant: 'Veidne',

  // 知识库搜索
  enableKnowledgeSearch: 'Iespējot meklēšanu',
  knowledgeSearchDesc: 'AI meklē jūsu dokumentos',
  clickToDisable: 'Atspējot',
  clickToEnable: 'Iespējot',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Aizvērt resursu paneli',
  uploading: 'Augšupielādē %{fileName}...',
  processing: 'Apstrādā %{fileName}...',
  uploadSuccess: '✓ %{fileName} augšupielādēts',
  uploadError: '✗ Augšupielāde neizdevās: %{error}',
  quickAnswer: 'Ātrā atbilde',
  quickAnswerDesc: 'Ātra atbilde uz vienkāršiem jautājumiem',
  cancelRequest: 'Atcelt',
  library: 'Bibliotēka',
  filterAll: 'Visi',
  filterChat: 'Sarunas',
  filterReview: 'Pārskats',
  filterDraft: 'Melnraksts',
  filterTemplate: 'Veidne',
  filterForm: 'Veidlapa',
  thinking: 'Domāju...',
  thinkingProcess: 'Domāšanas process',
  analyzingLegalLogic: 'Analizē juridisko loģiku...',
  lawhelperThinking: 'Lawhelper domā...',
  serviceError: 'Pakalpojuma kļūda',
  uploaded: 'Augšupielādēts',
  settingsGeneral: 'Vispārīgi',
  settingsNotifications: 'Paziņojumi',
  settingsAppearance: 'Izskats',
  settingsProfile: 'Profils',
  settingsResponseNotifications: 'Atbilžu paziņojumi',
  settingsResponseNotificationsDesc: 'Paziņojums, kad AI pabeidz atbildi',
  settingsColorMode: 'Krāsu režīms',
  settingsLight: 'Gaišs',
  settingsDark: 'Tumšs',
  settingsSystem: 'Sistēma',
  about: 'Par',
  reviewTitle: 'Dokumenta pārskatīšana',
  exitReview: 'Iziet no pārskata',
  uploadPrompt: 'Augšupielādējiet PDF pārskatam',
  uploadButton: 'Izvēlēties failu',
  startChatConfig: 'Ierakstiet "Pārskatīt šo dokumentu"',
  reviewPlaceholder: 'Ievadiet ziņojumu...',
  analyzing: 'Pārskata...',
  reviewComplete: 'Pārskats pabeigts',
  issuesFound: 'Atrastas %{count} problēmas',
  draftTitle: 'Juridiskā dokumenta sagatavošana',
  draftPlaceholder: 'Rediģējiet šeit vai lūdziet AI...',
  analyzingTemplate: 'Analizē veidni %{name}...',
  templateAnalyzed: '✅ Veidne %{name} analizēta!',
  templateAnalysisPrompt: 'Analizēt galvenās klauzulas',
  parsingFailed: '⚠️ Neizdevās analizēt failu.',
  generating: 'Ģenerē...',
  generatedSuccess: '✅ Dokuments izveidots!',
  drafterWelcome: 'Laipni lūgti AI dokumentu asistentā',
  drafterYouCan: 'Jūs varat:',
  drafterUploadTemplate: 'Augšupielādēt veidni AI analīzei',
  drafterDescribeNeeds: 'Aprakstīt dokumenta prasības',
  drafterLetAiHelp: 'AI palīdz ar līgumiem, vienošanām utt.',
  drafterExamples: 'Piemēri:',
  drafterExampleRental: '"Sagatavojiet īres līgumu"',
  drafterExampleLabor: '"Aizpildiet darba līgumu"',
  drafterInputPlaceholder: 'Aprakstiet vajadzības...',
  drafterThinking: 'Domāju...',
  drafterHistoryTitle: 'Vēsture',
  drafterNoHistory: 'Nav vēstures',
  drafterNewChat: 'Jauna saruna',
  drafterHistory: 'Vēsture',
  drafterRemoveAttachment: 'Noņemt pielikumu',
  drafterLineHeight: 'Rindas augstums',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Eksportēt kā Word (.docx)',
  drafterExportPdf: 'Eksportēt kā PDF',
  drafterSave: 'Saglabāt dokumentu',
  drafterDownload: 'Lejupielādēt dokumentu',
  drafterUndo: 'Atsaukt',
  drafterRedo: 'Atkārtot',
  drafterBold: 'Treknraksts',
  drafterItalic: 'Slīpraksts',
  drafterStrike: 'Pārsvītrots',
  drafterUnderline: 'Pasvītrots',
  drafterHighlight: 'Izcelt',
  drafterLink: 'Ievietot saiti',
  drafterAlignLeft: 'Pa kreisi',
  drafterAlignCenter: 'Centrēt',
  drafterAlignRight: 'Pa labi',
  drafterAlignJustify: 'Taisnot',
  drafterList: 'Saraksts',
  drafterBulletList: 'Aizzīmju saraksts',
  drafterOrderedList: 'Numurēts saraksts',
  drafterTaskList: 'Uzdevumu saraksts',
  drafterOpenResource: 'Atvērt resursus',
  drafterStopGeneration: 'Apturēt ģenerēšanu',
  drafterAgentMode: 'Aģenta režīms aktīvs',
  drafterAgentModeOn: 'Aģenta režīms aktīvs',
  drafterAgentModeOff: 'Parastais režīms',
  drafterUploadAttachment: 'Augšupielādēt pielikumu',
  drafterExit: 'Iziet',
  drafterConfirm: 'Apstiprināt',
  drafterOpenLink: 'Atvērt saiti',
  drafterDeleteLink: 'Dzēst saiti',
  drafterQuote: 'Citāts',
  workflowTitle: 'AI darbplūsma',
  workflowRunning: 'Izpilda...',
  workflowReady: 'Gatavs',
  workflowCompleted: 'Pabeigts',
  workflowStartFailed: 'Neizdevās sākt',
  workflowExecutionFailed: 'Neizdevās izpildīt',
  workflowInterrupted: 'Darbplūsma pārtraukta',
  workflowProcessing: 'Apstrādā...',
  workflowStepsCompleted: 'soļi pabeigti',
  workflowStepsTotal: 'Darbplūsma pabeigta (%{count} soļi)',
  acceptChanges: 'Pieņemt izmaiņas',
  rejectChanges: 'Noraidīt izmaiņas',
  changesAccepted: 'Izmaiņas pieņemtas',
  changesRejected: 'Izmaiņas noraidītas',
  stopWorkflow: 'Apturēt',
  restartWorkflow: 'Restartēt',
  startDrafting: 'Sākt sagatavošanu',
  interrupt: 'Apturēt',
  documentSubject: 'Dokumenta tēma *',
  documentType: 'Dokumenta veids',
  jurisdiction: 'Jurisdikcija',
  specialRequirements: 'Īpašas prasības (neobligāti)',
  clickStartDrafting: 'Nospiediet "Sākt sagatavošanu"',
  docTypeContract: 'Līgums',
  docTypeAgreement: 'Vienošanās',
  docTypeNotice: 'Paziņojums',
  docTypeLetter: 'Vēstule',
  docTypePetition: 'Petīcija',
  docTypeWill: 'Testaments',
  docTypePowerOfAttorney: 'Pilnvara',
  countryChina: 'Ķīna',
  countryUSA: 'ASV',
  countryGermany: 'Vācija',
  countryJapan: 'Japāna',
  countryFrance: 'Francija',
  countryUK: 'Apvienotā Karaliste',
  citationVerified: 'Verificēts',
  citationUnverified: 'Neverificēts',
  imageLoadFailed: 'Neizdevās ielādēt attēlu',
  smartDocTitle: 'Viedais dokumentu asistents',
  smartDocChatTitle: 'AI dokumentu asistents',
  smartDocDropPrompt: 'Nometiet PDF šeit',
  smartDocSelectFile: 'Izvēlēties failu',
  smartDocOr: 'vai',
  smartDocWelcomeTitle: 'Laipni lūgti AI asistentā',
  smartDocWelcomeYouCan: 'Jūs varat:',
  smartDocUploadForAI: 'Augšupielādēt veidni',
  smartDocDescribeDoc: 'Aprakstīt prasības',
  smartDocLetAIDraft: 'AI palīdz ar līgumiem',
  smartDocExamples: 'Piemēri:',
  smartDocExampleRental: '"Sagatavojiet īres līgumu"',
  smartDocExampleLabor: '"Aizpildiet darba līgumu"',
  smartDocInputPlaceholder: 'Aprakstiet vajadzības...',
  smartDocRemoveAttachment: 'Noņemt pielikumu',
  smartDocOpenResources: 'Atvērt resursus',
  smartDocExit: 'Iziet',
  reviewStartFailed: 'Neizdevās sākt pārskatu',
  reviewFailed: 'Pārskats neizdevās',
  reviewFoundIssues: 'Pārskats pabeigts, %{count} problēmas.',
  cannotReadStream: 'Nevar nolasīt plūsmu',
  parseEventFailed: 'Neizdevās analizēt notikumu',
  errorPrefix: 'Kļūda',
  unknownError: 'Nezināma kļūda',
  file: 'Fails',
  loading: 'Ielādē...',
  localFolders: 'Lokālās mapes',
  selectLocalFolder: 'Izvēlēties lokālo mapi',
  reselectFolder: 'Mainīt mapi',
  addToContext: 'Pievienot sarunai',
  saveFile: 'Saglabāt',
  renameFile: 'Pārdēvēt',
  fileSaved: 'Fails saglabāts',
  fileRenamed: 'Fails pārdēvēts par %{name}',
  browserNotSupported: 'Pārlūks neatbalsta piekļuvi mapēm',
  noFolderSelected: 'Izvēlieties lokālo mapi',
  scanningFolder: 'Skenē mapi...',
  selectFileToPreview: 'Izvēlieties failu priekšskatījumam',
  aiAnalyze: 'AI analīze',
};
